{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} и {{ moreCount }} еще",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} и {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} файл",
  "{{ count }} files_few": "{{ count }} файла",
  "{{ count }} files_many": "{{ count }} файлов",
  "{{ count }} files_other": "{{ count }} файла",
  "{{ count }} members_one": "{{ count }} участник",
  "{{ count }} members_few": "{{ count }} участника",
  "{{ count }} members_many": "{{ count }} участников",
  "{{ count }} members_other": "{{ count }} участника",
  "{{ count }} members added_one": "{{ count }} участник добавлен",
  "{{ count }} members added_few": "{{ count }} участника добавлены",
  "{{ count }} members added_many": "{{ count }} участников добавлено",
  "{{ count }} members added_other": "{{ count }} участника добавлены",
  "{{ count }} people are typing_one": "{{ count }} человек печатает",
  "{{ count }} people are typing_few": "{{ count }} человека печатают",
  "{{ count }} people are typing_many": "{{ count }} человек печатают",
  "{{ count }} people are typing_other": "{{ count }} человека печатают",
  "{{ count }} photos_one": "{{ count }} фото",
  "{{ count }} photos_few": "{{ count }} фото",
  "{{ count }} photos_many": "{{ count }} фото",
  "{{ count }} photos_other": "{{ count }} фото",
  "{{ count }} reactions_one": "{{ count }} реакция",
  "{{ count }} reactions_few": "{{ count }} реакции",
  "{{ count }} reactions_many": "{{ count }} реакций",
  "{{ count }} reactions_other": "{{ count }} реакций",
  "{{ count }} videos_one": "{{ count }} видео",
  "{{ count }} videos_few": "{{ count }} видео",
  "{{ count }} videos_many": "{{ count }} видео",
  "{{ count }} videos_other": "{{ count }} видео",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} и {{ secondUser }}",
  "{{ imageCount }} more": "Ещё {{ imageCount }}",
  "{{ member }} will be able to message you again.": "{{ member }} снова сможет отправлять вам сообщения.",
  "{{ member }} won't be able to message you anymore.": "{{ member }} больше не сможет отправлять вам сообщения.",
  "{{ memberCount }} members": "{{ memberCount }} участников",
  "{{ typing }} are typing": "{{ typing }} печатают",
  "{{ typing }} is typing": "{{ typing }} печатает",
  "{{ user }} has been muted": "Вы отписались от уведомлений от {{ user }}",
  "{{ user }} has been unmuted": "Уведомления от {{ user }} были включены",
  "{{ user }} is typing...": "{{ user }} печатает...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} и {{ user }} печатают...",
  "{{ users }} and more are typing...": "{{ users }} и другие печатают...",
  "{{ watcherCount }} online": "{{ watcherCount }} в сети",
  "{{count}} new messages_one": "{{count}} новое сообщение",
  "{{count}} new messages_few": "{{count}} новых сообщения",
  "{{count}} new messages_many": "{{count}} новых сообщений",
  "{{count}} new messages_other": "{{count}} новых сообщений",
  "{{count}} unread_one": "{{count}} непрочитанное",
  "{{count}} unread_few": "{{count}} непрочитанных",
  "{{count}} unread_many": "{{count}} непрочитанных",
  "{{count}} unread_other": "{{count}} непрочитанных",
  "{{count}} votes_one": "{{count}} голос",
  "{{count}} votes_few": "{{count}} голоса",
  "{{count}} votes_many": "{{count}} голосов",
  "{{count}} votes_other": "{{count}} голосов",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+ещё {{count}} вариант",
  "+{{count}} more options_few": "+ещё {{count}} варианта",
  "+{{count}} more options_many": "+ещё {{count}} вариантов",
  "+{{count}} more options_other": "+ещё {{count}} вариантов",
  "🏙 Attachment...": "🏙 Вложение...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} создал(а): {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} проголосовал(а): {{pollOptionText}}",
  "📍Shared location": "📍Общее местоположение",
  "Actions": "Actions",
  "Add": "Добавить",
  "Add {{ count }} members_one": "Добавить {{ count }} участника",
  "Add {{ count }} members_few": "Добавить {{ count }} участников",
  "Add {{ count }} members_many": "Добавить {{ count }} участников",
  "Add {{ count }} members_other": "Добавить {{ count }} участника",
  "Add a comment": "Добавить комментарий",
  "Add a comment to your poll answer": "Добавьте комментарий к вашему ответу в опросе",
  "Add an option": "Добавить вариант",
  "Add channel members": "Добавить участников канала",
  "Add members": "Добавить участников",
  "Add reaction": "Добавить реакцию",
  "Admin": "Администратор",
  "All results loaded": "Все результаты загружены",
  "Allow access to camera": "Разрешить доступ к камере",
  "Allow access to microphone": "Разрешить доступ к микрофону",
  "Allow comments": "Разрешить комментарии",
  "Allow option suggestion": "Разрешить предложение вариантов",
  "Allow others to add comments": "Разрешить другим добавлять комментарии",
  "Already a member": "Уже участник",
  "Also send as a direct message": "Также отправить как личное сообщение",
  "Also send in channel": "Также отправить в канал",
  "Also sent in channel": "Также отправлено в канал",
  "An error has occurred during recording": "Произошла ошибка во время записи",
  "An error has occurred during the recording processing": "Произошла ошибка во время обработки записи",
  "Anonymous": "Аноним",
  "Anonymous poll": "Анонимный опрос",
  "Archive": "Aрхивировать",
  "Are you sure you want to delete this message?": "Вы уверены, что хотите удалить это сообщение?",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "Вложение",
  "aria/Attachment Actions": "Действия с вложением",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Позиция аудио {{ elapsed }} из {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Позиция аудио {{ progress }} процентов",
  "aria/Block User": "Заблокировать пользователя",
  "aria/Bookmark Message": "Сохранить сообщение",
  "aria/Cancel recording": "Отменить запись",
  "aria/Cancel Reply": "Отменить ответ",
  "aria/Cancel upload": "Отменить загрузку",
  "aria/Channel Actions": "Действия канала",
  "aria/Channel details": "Сведения о канале",
  "aria/Channel list": "Список каналов",
  "aria/Channel search results": "Результаты поиска по каналам",
  "aria/Chat view tabs": "Вкладки вида чата",
  "aria/Clear search": "Очистить поиск",
  "aria/Close callout dialog": "Закрыть диалог выноски",
  "aria/Close thread": "Закрыть тему",
  "aria/Collapse sidebar": "Свернуть боковую панель",
  "aria/Command Suggestions": "Подсказки команд",
  "aria/Complete recording": "Завершить запись",
  "aria/Copy Message Text": "Копировать текст сообщения",
  "aria/Decrease value": "Уменьшить значение",
  "aria/Delete Message": "Удалить сообщение",
  "aria/Dismiss notification": "Закрыть уведомление",
  "aria/Download attachment": "Скачать вложение",
  "aria/Edit Message": "Редактировать сообщение",
  "aria/Emoji picker": "Выбор эмодзи",
  "aria/Emoji Suggestions": "Подсказки эмодзи",
  "aria/Exit search": "Выйти из поиска",
  "aria/Expand sidebar": "Развернуть боковую панель",
  "aria/File input": "Ввод файла",
  "aria/File upload": "Загрузка файла",
  "aria/Flag Message": "Пожаловаться на сообщение",
  "aria/Image failed to load": "Не удалось загрузить изображение",
  "aria/Image input": "Ввод изображения",
  "aria/Increase value": "Увеличить значение",
  "aria/Jump to latest message": "Перейти к последнему сообщению",
  "aria/Jump to quoted message": "Перейти к цитируемому сообщению",
  "aria/Load More Channels": "Загрузить больше каналов",
  "aria/Mark Message Unread": "Отметить как непрочитанное",
  "aria/Mark messages as read": "Отметить сообщения как прочитанные",
  "aria/Mention Suggestions": "Подсказки упоминаний",
  "aria/Menu": "Меню",
  "aria/Message Actions": "Действия с сообщением",
  "aria/Message from {{ user }},": "Сообщение от {{ user }},",
  "aria/Message Options": "Параметры сообщения",
  "aria/Message,": "Сообщение,",
  "aria/Mute User": "Отключить уведомления",
  "aria/Next page": "Следующая страница",
  "aria/Notifications": "Уведомления",
  "aria/Open Attachment Selector": "Открыть выбор вложений",
  "aria/Open Channel Actions Menu": "Открыть меню действий канала",
  "aria/Open channel details": "Открыть сведения о канале",
  "aria/Open image shared by {{ name }}": "Открыть изображение от {{ name }}",
  "aria/Open Menu": "Открыть меню",
  "aria/Open Message Actions Menu": "Открыть меню действий с сообщениями",
  "aria/Open Reaction Selector": "Открыть селектор реакций",
  "aria/Open Thread": "Открыть тему",
  "aria/Open video shared by {{ name }}": "Открыть видео от {{ name }}",
  "aria/Pause": "Пауза",
  "aria/Pause recording": "Приостановить запись",
  "aria/Percent complete": "{{percent}} процентов завершено",
  "aria/Pin Message": "Закрепить сообщение",
  "aria/Play": "Воспроизвести",
  "aria/Previous page": "Предыдущая страница",
  "aria/Quote Message": "Цитировать сообщение",
  "aria/Reaction list": "Список реакций",
  "aria/Remind Me Message": "Напомнить мне",
  "aria/Remind Me Options": "Параметры напоминания",
  "aria/Remove attachment": "Удалить вложение",
  "aria/Remove location attachment": "Удалить вложение местоположения",
  "aria/Remove option": "Удалить вариант",
  "aria/Remove Reminder": "Удалить напоминание",
  "aria/Remove Save For Later": "Удалить «Сохранить на потом»",
  "aria/Resend Message": "Отправить сообщение повторно",
  "aria/Resume recording": "Возобновить запись",
  "aria/Retry upload": "Повторить загрузку",
  "aria/Review bounced message": "Проверить отклонённое сообщение",
  "aria/Search results": "Результаты поиска",
  "aria/Search results header filter button for: {{ source }}": "Кнопка фильтра заголовка результатов поиска для: {{ source }}",
  "aria/Seek audio position": "Перемотать аудио",
  "aria/Select Channel: {{ channelName }}": "Выбрать канал: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Выбрать реакцию: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Выбрать пользовательский канал: {{ name }}",
  "aria/Send": "Отправить",
  "aria/Show preview": "Показать предпросмотр",
  "aria/Start recording audio": "Начать запись аудио",
  "aria/Stop AI Generation": "Остановить генерацию ИИ",
  "aria/Suggestions": "Подсказки",
  "aria/Thread list": "Список тредов",
  "aria/Unblock User": "Разблокировать пользователя",
  "aria/Unmute User": "Включить уведомления",
  "aria/Unpin Message": "Открепить сообщение",
  "Ask a question": "Задать вопрос",
  "Attach": "Прикрепить",
  "Attach files": "Прикрепить файлы",
  "Attachment": "Вложение",
  "Attachment upload blocked due to {{reason}}": "Загрузка вложения заблокирована из-за {{reason}}",
  "Attachment upload failed due to {{reason}}": "Загрузка вложения не удалась из-за {{reason}}",
  "Back": "Назад",
  "ban-command-args": "[@имяпользователя] [текст]",
  "ban-command-description": "Заблокировать пользователя",
  "Block user": "Заблокировать пользователя",
  "Block User": "Заблокировать пользователя",
  "Browse channel members": "Просмотреть участников канала",
  "Browse pinned messages": "Просмотреть закрепленные сообщения",
  "Cancel": "Отмена",
  "Cannot seek in the recording": "Невозможно осуществить поиск в записи",
  "Changes saved": "Изменения сохранены",
  "Channel archived": "Канал в архиве",
  "Channel members": "Участники канала",
  "Channel Missing": "Канал не найден",
  "Channel muted": "Канал заглушён",
  "Channel pinned": "Канал закреплён",
  "Channel unarchived": "Канал извлечён из архива",
  "Channel unmuted": "Заглушение канала снято",
  "Channel unpinned": "Канал откреплён",
  "Channels": "Каналы",
  "Chat deleted": "Chat deleted",
  "Chats": "Чаты",
  "Choose between 2 to 10 options": "Выберите от 2 до 10 вариантов",
  "Close": "Закрыть",
  "Close dialog": "Закрыть диалог",
  "Close emoji picker": "Закрыть окно выбора смайлов",
  "Close prompt: {{ title }}": "Закрыть запрос: {{ title }}",
  "Command not available while editing": "Команда недоступна при редактировании",
  "Command not available while replying": "Команда недоступна при ответе",
  "Commands": "Команды",
  "Commands matching": "Соответствие команд",
  "Connection failure, reconnecting now...": "Ошибка соединения, переподключение...",
  "Contact info": "Информация о контакте",
  "Contact name": "Имя контакта",
  "Copy Message": "Копировать сообщение",
  "Create": "Создать",
  "Create a question, add options, and configure poll settings": "Создайте вопрос, добавьте варианты и настройте параметры опроса",
  "Create poll": "Создать опрос",
  "Current location": "Текущее местоположение",
  "Delete": "Удалить",
  "Delete chat": "Удалить чат",
  "Delete for me": "Удалить для меня",
  "Delete message": "Удалить сообщение",
  "Delivered": "Отправлено",
  "Direct message": "Личное сообщение",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Вы хотите завершить этот опрос сейчас? После этого никто не сможет голосовать в этом опросе.",
  "Download All": "Скачать всё",
  "Download Attachment": "Скачать вложение",
  "Download attachment {{ name }}": "Скачать вложение {{ name }}",
  "Drag your files here": "Перетащите ваши файлы сюда",
  "Drag your files here to add to your post": "Перетащите ваши файлы сюда, чтобы добавить их в ваш пост",
  "Due {{ timeLeft }}": "Просрочено в {{ timeLeft }}",
  "Due since {{ dueSince }}": "Просрочено с {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "Редактировать",
  "Edit chat data": "Редактировать данные чата",
  "Edit contact": "Редактировать контакт",
  "Edit group": "Редактировать группу",
  "Edit Message": "Редактировать сообщение",
  "Edit message request failed": "Не удалось изменить запрос сообщения",
  "Edited": "Отредактировано",
  "Emoji matching": "Соответствие эмодзи",
  "Empty message...": "Пустое сообщение...",
  "End": "Конец",
  "End poll": "Завершить опрос",
  "End this poll?": "Завершить этот опрос?",
  "End vote": "Закончить голосование",
  "Enforce unique vote is enabled": "Уникальное голосование включено",
  "Error": "Ошибка",
  "Error adding flag": "Ошибка добавления флага",
  "Error adding members": "Error adding members",
  "Error blocking user": "Ошибка при блокировке пользователя",
  "Error connecting to chat, refresh the page to try again.": "Ошибка подключения к чату, обновите страницу чтобы попробовать снова.",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "Ошибка при удалении сообщения",
  "Error fetching reactions": "Ошибка при загрузке реакций",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Ошибка при отметке сообщения как непрочитанного. Невозможно отметить как непрочитанные сообщения старше последних 100 сообщений в канале.",
  "Error muting a user ...": "Ошибка отключения уведомлений от пользователя...",
  "Error muting channel": "Ошибка при отключении уведомлений канала",
  "Error muting user": "Ошибка при отключении уведомлений пользователя",
  "Error opening direct message": "Ошибка при открытии личного сообщения",
  "Error pinning message": "Сообщение об ошибке при закреплении",
  "Error removing members": "Ошибка при удалении участников",
  "Error removing message pin": "Ошибка при удалении булавки сообщения",
  "Error removing user": "Ошибка при удалении пользователя",
  "Error reproducing the recording": "Ошибка воспроизведения записи",
  "Error starting recording": "Ошибка при запуске записи",
  "Error unblocking user": "Ошибка при разблокировке пользователя",
  "Error unmuting a user ...": "Ошибка включения уведомлений...",
  "Error unmuting channel": "Ошибка при включении уведомлений канала",
  "Error unmuting user": "Ошибка при включении уведомлений пользователя",
  "Error uploading attachment": "Ошибка при загрузке вложения",
  "Error uploading file": "Ошибка при загрузке файла",
  "Error uploading image": "Ошибка загрузки изображения",
  "Error: {{ errorMessage }}": "Ошибка: {{ errorMessage }}",
  "Exit command {{ command }}": "Выйти из команды {{ command }}",
  "Failed to block user": "Не удалось заблокировать пользователя",
  "Failed to create the poll": "Не удалось создать опрос",
  "Failed to create the poll due to {{reason}}": "Не удалось создать опрос из-за {{reason}}",
  "Failed to delete the message": "Не удалось удалить сообщение",
  "Failed to end the poll": "Не удалось завершить опрос",
  "Failed to end the poll due to {{reason}}": "Не удалось завершить опрос из-за {{reason}}",
  "Failed to jump to the first unread message": "Не удалось перейти к первому непрочитанному сообщению",
  "Failed to leave channel": "Не удалось покинуть канал",
  "Failed to load channels": "Не удалось загрузить каналы",
  "Failed to load more channels": "Не удалось загрузить больше каналов",
  "Failed to mark channel as read": "Не удалось пометить канал как прочитанный",
  "Failed to play the recording": "Не удалось воспроизвести запись",
  "Failed to retrieve location": "Не удалось получить местоположение",
  "Failed to save changes": "Не удалось сохранить изменения",
  "Failed to share location": "Не удалось поделиться местоположением",
  "Failed to update channel archive status": "Не удалось обновить статус архивации канала",
  "Failed to update channel mute status": "Не удалось обновить статус отключения звука канала",
  "Failed to update channel pinned status": "Не удалось обновить статус закрепления канала",
  "File": "Файл",
  "File is required for upload attachment": "Для загрузки вложения требуется файл",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Файл слишком большой: {{ size }}, максимальный размер загрузки составляет {{ limit }}",
  "File too large": "Файл слишком большой",
  "fileCount_one": "{{ count }} файл",
  "fileCount_few": "{{ count }} файла",
  "fileCount_four": "{{ count }} файла",
  "fileCount_two": "{{ count }} файла",
  "fileCount_many": "{{ count }} файлов",
  "fileCount_other": "{{ count }} файлов",
  "fileCount_three": "{{ count }} файла",
  "Files": "Файлы",
  "Flag": "Пожаловаться",
  "Generating...": "Генерирую...",
  "giphy-command-args": "[текст]",
  "giphy-command-description": "Опубликовать случайную GIF-анимацию в канале",
  "Go back": "Назад",
  "Group info": "Информация о группе",
  "Group name": "Название группы",
  "Hide who voted": "Скрыть, кто голосовал",
  "Image": "Изображение",
  "imageCount_one": "{{ count }} изображение",
  "imageCount_few": "{{ count }} изображения",
  "imageCount_many": "{{ count }} изображений",
  "imageCount_other": "{{ count }} изображений",
  "Instant commands": "Мгновенные команды",
  "language/af": "Африкаанс",
  "language/am": "Амхарский",
  "language/ar": "Арабский",
  "language/az": "Азербайджанский",
  "language/bg": "Болгарский",
  "language/bn": "Бенгальский",
  "language/bs": "Боснийский",
  "language/cs": "Чешский",
  "language/da": "Датский",
  "language/de": "Немецкий",
  "language/el": "Греческий",
  "language/en": "Английский",
  "language/es": "Испанский",
  "language/es-MX": "Испанский (Мексика)",
  "language/et": "Эстонский",
  "language/fa": "Персидский",
  "language/fa-AF": "Дари",
  "language/fi": "Финский",
  "language/fr": "Французский",
  "language/fr-CA": "Французский (Канада)",
  "language/ha": "Хауса",
  "language/he": "Иврит",
  "language/hi": "Хинди",
  "language/hr": "Хорватский",
  "language/ht": "Гаитянский креольский",
  "language/hu": "Венгерский",
  "language/id": "Индонезийский",
  "language/it": "Итальянский",
  "language/ja": "Японский",
  "language/ka": "Грузинский",
  "language/ko": "Корейский",
  "language/lt": "Литовский",
  "language/lv": "Латышский",
  "language/ms": "Малайский",
  "language/nl": "Нидерландский",
  "language/no": "Норвежский",
  "language/pl": "Польский",
  "language/ps": "Пушту",
  "language/pt": "Португальский",
  "language/ro": "Румынский",
  "language/ru": "Русский",
  "language/sk": "Словацкий",
  "language/sl": "Словенский",
  "language/so": "Сомали",
  "language/sq": "Албанский",
  "language/sr": "Сербский",
  "language/sv": "Шведский",
  "language/sw": "Суахили",
  "language/ta": "Тамильский",
  "language/th": "Тайский",
  "language/tl": "Тагальский",
  "language/tr": "Турецкий",
  "language/uk": "Украинский",
  "language/ur": "Урду",
  "language/vi": "Вьетнамский",
  "language/zh": "Китайский (упрощённый)",
  "language/zh-TW": "Китайский (традиционный)",
  "Last seen {{ timestamp }}": "Был(а) в сети {{ timestamp }}",
  "Leave Channel": "Покинуть канал",
  "Leave chat": "Покинуть канал",
  "Left channel": "Канал покинут",
  "Let others add options": "Разрешить другим добавлять варианты",
  "Limit votes per person": "Ограничить голоса на человека",
  "Link": "Линк",
  "linkCount_one": "{{ count }} линк",
  "linkCount_few": "{{ count }} линка",
  "linkCount_many": "{{ count }} линков",
  "linkCount_other": "{{ count }} линков",
  "live": "В прямом эфире",
  "Live for {{duration}}": "В прямом эфире {{duration}}",
  "Live location": "Местоположение в прямом эфире",
  "Live until {{ timestamp }}": "В прямом эфире до {{ timestamp }}",
  "Load more": "Загрузить больше",
  "Local upload attachment missing local id": "У локального вложения нет локального id",
  "Location": "Местоположение",
  "Location sharing ended": "Обмен местоположением завершен",
  "Location: {{ coordinates }}": "Местоположение: {{ coordinates }}",
  "Manage channel": "Управлять каналом",
  "Manage members": "Управлять участниками",
  "Mark as unread": "Отметить как непрочитанное",
  "Maximum number of votes (from 2 to 10)": "Максимальное количество голосов (от 2 до 10)",
  "Maximum votes per person": "Максимум голосов на человека",
  "Member detail": "Сведения об участнике",
  "mention/Channel": "Канал",
  "mention/Channel Description": "Уведомить всех в этом канале",
  "mention/Here": "Здесь",
  "mention/Here Description": "Уведомить всех онлайн-участников в этом канале",
  "Menu": "Меню",
  "Message deleted": "Сообщение удалено",
  "Message failed to send": "Не удалось отправить сообщение",
  "Message has been successfully flagged": "Жалоба на сообщение была принята",
  "Message marked as unread": "Сообщение помечено как непрочитанное",
  "Message pinned": "Сообщение закреплено",
  "Message unpinned": "Сообщение откреплено",
  "Message was blocked by moderation policies": "Сообщение было заблокировано модерацией",
  "Messages have been marked unread.": "Сообщения были отмечены как непрочитанные.",
  "Missing permissions to upload the attachment": "Отсутствуют разрешения для загрузки вложения",
  "Moderator": "Модератор",
  "Multiple votes": "Несколько голосов",
  "Mute": "Отключить уведомления",
  "Mute chat": "Отключить уведомления чата",
  "Mute user": "Отключить уведомления пользователя",
  "mute-command-args": "[@имяпользователя]",
  "mute-command-description": "Выключить микрофон у пользователя",
  "network error": "ошибка сети",
  "New": "Новые",
  "New message from {{user}}": "Новое сообщение от {{user}}",
  "New Messages!": "Новые сообщения!",
  "Next": "Далее",
  "Next image": "Следующее изображение",
  "No chats here yet…": "Здесь еще нет чатов...",
  "No conversations yet": "Пока нет бесед",
  "No files": "Нет файлов",
  "No items exist": "Элементов нет",
  "No member found": "Участник не найден",
  "No messages found": "Сообщения не найдены",
  "No photos or videos": "Нет фото или видео",
  "No pinned messages": "Нет закрепленных сообщений",
  "No results found": "Результаты не найдены",
  "No user found": "Пользователь не найден",
  "Nobody will be able to vote in this poll anymore.": "Никто больше не сможет голосовать в этом опросе.",
  "Nothing yet...": "Пока ничего нет...",
  "Notify all {{ role }} members": "Уведомить всех участников с ролью {{ role }}",
  "Offline": "Не в сети",
  "Ok": "Ок",
  "Online": "В сети",
  "Only numbers are allowed": "Разрешены только цифры",
  "Only visible to you": "Видно только вам",
  "Open emoji picker": "Открыть выбор смайлов",
  "Open gallery at image {{ index }}": "Открыть галерею на изображении {{ index }}",
  "Open image in gallery": "Открыть изображение в галерее",
  "Open location in a map": "Открыть местоположение на карте",
  "Open members actions": "Open members actions",
  "Open menu": "Открыть меню",
  "Option already exists": "Вариант уже существует",
  "Option is empty": "Вариант пуст",
  "Options": "Варианты",
  "Original": "Оригинал",
  "Owner": "Владелец",
  "People matching": "Совпадающие люди",
  "Photo": "Фото",
  "Photos & videos": "Фото и видео",
  "Pin": "Закрепить",
  "Pin a message to see it here": "Закрепите сообщение, чтобы увидеть его здесь",
  "Pinned by {{ name }}": "Закреплено: {{ name }}",
  "Pinned by You": "Закреплено вами",
  "Pinned message": "Закрепленное сообщение",
  "Pinned messages": "Закрепленные сообщения",
  "placeholder/PollComment": "Ваш комментарий",
  "placeholder/PollOptionSuggestion": "Введите новый вариант",
  "Play video": "Воспроизвести видео",
  "Playback speed {{ rate }}x": "Скорость воспроизведения {{ rate }}x",
  "Poll": "Опрос",
  "Poll comments": "Комментарии к опросу",
  "Poll ended": "Опрос завершён",
  "Poll options": "Опции опроса",
  "Poll results": "Результаты опроса",
  "Previous": "Назад",
  "Previous image": "Предыдущее изображение",
  "Question": "Вопрос",
  "Question {{ optionOrderNumber}}": "Вопрос {{ optionOrderNumber}}",
  "Question is required": "Вопрос обязателен",
  "Quote Reply": "Ответ со цитатой",
  "Reached the vote limit. Remove an existing vote first.": "Достигнут лимит голосов. Сначала удалите существующий голос.",
  "Recording format is not supported and cannot be reproduced": "Формат записи не поддерживается и не может быть воспроизведен",
  "Remind me": "Напомнить мне",
  "Remind Me": "Напомнить мне",
  "Reminder set": "Напоминание установлено",
  "Remove": "Удалить",
  "Remove {{ count }} members_one": "Удалить {{ count }} участника",
  "Remove {{ count }} members_few": "Удалить {{ count }} участника",
  "Remove {{ count }} members_many": "Удалить {{ count }} участников",
  "Remove {{ count }} members_other": "Удалить {{ count }} участника",
  "Remove {{ member }} from this channel?": "Удалить {{ member }} из этого канала?",
  "Remove channel members": "Удалить участников канала",
  "Remove reminder": "Удалить напоминание",
  "Remove save for later": "Удалить «Сохранить на потом»",
  "Remove user": "Удалить пользователя",
  "Removed {{ count }} members_one": "Удалён {{ count }} участник",
  "Removed {{ count }} members_few": "Удалены {{ count }} участника",
  "Removed {{ count }} members_many": "Удалено {{ count }} участников",
  "Removed {{ count }} members_other": "Удалено {{ count }} участников",
  "Replied to a thread": "Ответил в ветке",
  "Reply": "Ответить",
  "Reply to {{ authorName }}": "Ответить {{ authorName }}",
  "Reply to a message to start a thread": "Ответьте на сообщение, чтобы начать тред",
  "Reply to Message": "Ответить на сообщение",
  "replyCount_one": "1 ответ",
  "replyCount_few": "{{ count }} ответов",
  "replyCount_many": "{{ count }} ответов",
  "replyCount_other": "{{ count }} ответов",
  "Resend": "Отправить повторно",
  "Retry upload": "Повторить загрузку",
  "Review all options available in this poll": "Просмотрите все варианты, доступные в этом опросе",
  "Review comments submitted with poll answers": "Просмотрите комментарии, отправленные вместе с ответами в опросе",
  "Review poll results and open an option to see detailed votes": "Просмотрите результаты опроса и откройте вариант, чтобы увидеть подробные голоса",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Просмотрите это сообщение и выберите, удалить его, отредактировать или отправить все равно",
  "Review who voted for this option": "Просмотрите, кто проголосовал за этот вариант",
  "Save": "Сохранить",
  "Save for later": "Сохранить на потом",
  "Saved for later": "Сохранено на потом",
  "Search": "Поиск",
  "Search GIFs": "Поиск GIF",
  "search-results-header-filter-source-button-label--channels": "каналы",
  "search-results-header-filter-source-button-label--messages": "сообщения",
  "search-results-header-filter-source-button-label--users": "пользователи",
  "Searching for {{ searchSourceType }}...": "Поиск {{ searchSourceType }}...",
  "Searching...": "Ищем...",
  "searchResultsCount_one": "1 результат",
  "searchResultsCount_few": "{{ count }} результата",
  "searchResultsCount_many": "{{ count }} результатов",
  "searchResultsCount_other": "{{ count }} результатов",
  "Select a thread to continue the conversation": "Выберите тред, чтобы продолжить беседу",
  "Select more than one option": "Выберите более одного варианта",
  "Select one": "Выберите один",
  "Select one or more": "Выберите один или несколько",
  "Select up to {{count}}_one": "Выберите до {{count}}",
  "Select up to {{count}}_few": "Выберите до {{count}}",
  "Select up to {{count}}_many": "Выберите до {{count}}",
  "Select up to {{count}}_other": "Выберите до {{count}}",
  "Select your current location and optionally enable live location sharing": "Выберите ваше текущее местоположение и при необходимости включите передачу геопозиции в реальном времени",
  "Send": "Отправить",
  "Send a message": "Отправьте сообщение",
  "Send a message to start the conversation": "Отправьте сообщение, чтобы начать разговор",
  "Send Anyway": "Мне всё равно, отправить",
  "Send direct message": "Отправить личное сообщение",
  "Send message request failed": "Не удалось отправить запрос на отправку сообщения",
  "Send poll": "Отправить опрос",
  "Sending...": "Отправка...",
  "Sent": "Отправлено",
  "Share": "Поделиться",
  "Share a file to see it here": "Поделитесь файлом, чтобы увидеть его здесь",
  "Share a photo or video to see it here": "Поделитесь фото или видео, чтобы увидеть их здесь",
  "Share live location for": "Поделиться местоположением в прямом эфире на",
  "Share Location": "Поделиться местоположением",
  "Shared live location": "Общее местоположение в прямом эфире",
  "Shared location": "Общее местоположение",
  "Shuffle": "Перемешать",
  "size limit": "ограничение размера",
  "Slow Mode ON": "Медленный режим включен",
  "Slow mode, wait {{ seconds }}s...": "Медленный режим: подождите {{ seconds }} с...",
  "Some of the files will not be accepted": "Некоторые файлы не будут приняты",
  "Start typing to search": "Начните вводить для поиска",
  "Stop sharing": "Прекратить делиться",
  "Submit": "Отправить",
  "Suggest a new option to add to this poll": "Предложите новый вариант для добавления в этот опрос",
  "Suggest an option": "Предложить вариант",
  "Tap to remove": "Нажмите, чтобы удалить",
  "Tap to remove: {{ reactionName }}": "Нажмите, чтобы удалить: {{ reactionName }}",
  "Thinking...": "Думаю...",
  "this content could not be displayed": "Этот контент не может быть отображен в данный момент",
  "This field cannot be empty or contain only spaces": "Это поле не может быть пустым или содержать только пробелы",
  "This message did not meet our content guidelines": "Сообщение не соответствует правилам",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "Этот пользователь снова сможет отправлять вам сообщения.",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "Ветка",
  "Thread has not been found": "Ветка не найдена",
  "Thread reply": "Ответ в ветке",
  "Thread Reply": "Ответ в ветке",
  "ThreadListUnseenThreadsBanner/loading": "Загрузка...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} непрочитанная ветка",
  "ThreadListUnseenThreadsBanner/unreadThreads_few": "{{ count }} непрочитанные ветки",
  "ThreadListUnseenThreadsBanner/unreadThreads_many": "{{ count }} непрочитанных веток",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} непрочитанных веток",
  "Threads": "Треды",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Вчера]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Сегодня]\", \"nextDay\": \"[Завтра]\", \"lastDay\": \"[Вчера]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[В прошлый] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }} дн. назад",
  "timestamp/relativeToday": "Сегодня",
  "timestamp/relativeWeeksAgo": "{{ count }} нед. назад",
  "timestamp/relativeYesterday": "Вчера",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Сегодня] [в] HH:mm\", \"nextDay\": \"[Завтра] [в] HH:mm\", \"lastDay\": \"[Вчера] [в] HH:mm\", \"nextWeek\": \"dddd [в] HH:mm\", \"lastWeek\": \"dddd [в] HH:mm\", \"sameElse\": \"ddd, D MMM [в] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Для начала записи разрешите доступ к камере в вашем браузере",
  "To start recording, allow the microphone access in your browser": "Для начала записи разрешите доступ к микрофону в вашем браузере",
  "totalVoteCount_one": "1 голос всего",
  "totalVoteCount_few": "{{ count }} голоса всего",
  "totalVoteCount_many": "{{ count }} голосов всего",
  "totalVoteCount_other": "{{ count }} голосов всего",
  "Translated": "Переведено",
  "Translated from {{ language }}": "Переведено с {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Введите число от 2 до 10",
  "Unarchive": "Удалить из архива",
  "unban-command-args": "[@имяпользователя]",
  "unban-command-description": "Разблокировать пользователя",
  "Unblock": "Разблокировать",
  "Unblock user": "Разблокировать пользователя",
  "Unblock User": "Разблокировать пользователя",
  "unknown error": "неизвестная ошибка",
  "Unmute": "Включить уведомления",
  "Unmute chat": "Включить уведомления чата",
  "Unmute user": "Включить уведомления пользователя",
  "unmute-command-args": "[@имяпользователя]",
  "unmute-command-description": "Включить микрофон у пользователя",
  "Unpin": "Открепить",
  "Unread messages": "Непрочитанные сообщения",
  "Unsupported attachment": "Неподдерживаемое вложение",
  "unsupported file type": "неподдерживаемый тип файла",
  "Update": "Обновить",
  "Update the comment attached to your poll answer": "Обновите комментарий, прикрепленный к вашему ответу в опросе",
  "Update your comment": "Обновите ваш комментарий",
  "Upload blocked": "Загрузка заблокирована",
  "Upload error": "Ошибка загрузки",
  "Upload failed": "Загрузка не удалась",
  "Upload Picture": "Загрузить изображение",
  "Upload type: \"{{ type }}\" is not allowed": "Тип загрузки: \"{{ type }}\" не разрешен",
  "User blocked": "Пользователь заблокирован",
  "User muted": "Уведомления пользователя отключены",
  "User removed": "Пользователь удалён",
  "User unblocked": "Пользователь разблокирован",
  "User unmuted": "Уведомления пользователя включены",
  "User uploaded content": "Пользователь загрузил контент",
  "Video": "Видео",
  "videoCount_one": "{{ count }} видео",
  "videoCount_few": "{{ count }} видео",
  "videoCount_many": "{{ count }} видео",
  "videoCount_other": "{{ count }} видео",
  "View": "Просмотр",
  "View {{count}} comments_one": "Просмотреть {{count}} комментарий",
  "View {{count}} comments_few": "Просмотреть {{count}} комментариев",
  "View {{count}} comments_many": "Просмотреть {{count}} комментариев",
  "View {{count}} comments_other": "Просмотреть {{count}} комментариев",
  "View all": "Показать все",
  "View member details for {{ member }}": "Просмотреть сведения об участнике {{ member }}",
  "View original": "Показать оригинал",
  "View results": "Посмотреть результаты",
  "View translation": "Показать перевод",
  "Voice message": "Голосовое сообщение",
  "Voice message {{ duration }}": "Голосовое сообщение {{ duration }}",
  "Voice message deleted": "Голосовое сообщение удалено",
  "voiceMessageCount_one": "{{ count }} голосовое сообщение",
  "voiceMessageCount_few": "{{ count }} голосовых сообщения",
  "voiceMessageCount_many": "{{ count }} голосовых сообщений",
  "voiceMessageCount_other": "{{ count }} голосовых сообщений",
  "Vote ended": "Голосование завершено",
  "Votes": "Голоса",
  "Wait until all attachments have uploaded": "Подождите, пока все вложения загрузятся",
  "Waiting for network…": "Ожидание сети…",
  "You": "Вы",
  "You've reached the maximum number of files": "Вы достигли максимального количества файлов"
}
